import {
  Box,
  Center, Flex, Grid, GridItem, Icon, Stack, Tag, TagLabel, Text, theme, useColorModeValue as mode
} from "@chakra-ui/react";
import Payment from "components/payment";
import { useSession } from "next-auth/react";
import { MdCheckCircle } from 'react-icons/md';
import { discounts, prices } from "./pricing";
import { PricingCard, PricingWrapper } from "./pricing-card";

// let priceGrowMonthly = 49;
// let priceGrowYearly = 36;
// let priceStartMonthly = 29;
// let priceStartYearly = 24;
// let priceEnterpriseMonthly = 200;
// let priceEnterpriseYearly = 167;
// let specialNoticeStart = "";
// let specialNoticeGrow = "";
// let planGrow = "grow";
// let specialGrowDiscount = "";
// let specialGrowDiscountYearly = "";

let now = new Date();
// let now = new Date(2021,8,18,0,0,0);
let startCounterDate = new Date(2021,11,25,0,0,0);
let endCounterDate = new Date(2021,11,25,23,59,59);
let diffDate = endCounterDate.getTime() - startCounterDate.getTime();
let startCount = 92;
let endCount = 7;

const growAt29 = [
    {code: "GROWINGACCOUNT", message: "< 1000 followers? Get 40% off GROW"},
    {code: "PRATHAM", message: "Special offer for Pratham's friends 👋"},
    {code: "GROWAT29", message: "Enjoy a unique offer"},
];

export const PlansEnterprise = ({
      discount,
      billingFrequency,
      customCancelUrl=undefined as string|undefined,
      isFromIndia = false,
      isEnterpriseOnly = false,
      ...rest
    }) => {
        
  const { data: session, status } = useSession() ?? {}
  const loading = status === "loading"


    const originalDiscount = discount;
    // handle url like ...utm_source=bfcmjk&discount=VIPOFFER&discount=VIPOFFER
    if (discount && Array.isArray(discount) && discount.length > 0) {
      discount = discount[0];
    }
    const isMonthly = billingFrequency === "monthly";
    
    let startPlanPrice = isMonthly ? prices.start.monthly.default : prices.start.yearly.default;
    let growPlanPrice = isMonthly ? prices.grow.monthly.default : prices.grow.yearly.default;
    let enterprisePlanPrice = isMonthly ? prices.enterprise.monthly.default : prices.enterprise.yearly.default;

    let specialNoticeGrow = "";
    let specialNoticeStart = "";

    let growDiscount = discount || "";
    // if (now < new Date(2021, 8, 27,23,59,59)) {
    //     priceGrowMonthly = 29;
    //     priceGrowYearly = 24;
    //     planGrow = "growLaunch"
    // }
    // if (discount == "EARLYBIRD" || discount == "EARLYACCESS") {
    //     priceGrowMonthly = Math.round(priceGrowMonthly * 19 / 29);
    // }
    
    // console.log("discount: " + discount);
    var promotion = growAt29.find(x => x.code == discount) as any;
    let isSmallAccount = session?.user?.data?.followers_count && session?.user?.data?.followers_count < 1000;
    
    var globalPromotion;
    // let ratio = (now.getTime() - startCounterDate.getTime()) / diffDate;
    // let counter = Math.round(startCount - (ratio * (startCount-endCount)));
    // console.log("ratio: " + ratio);
    // console.log("counter: " + counter);
    // if (now > startCounterDate && now < endCounterDate) {
    //     globalPromotion = {code: "", message: (<Text whiteSpace="pre-line"><b>{"X-Mas special\n"}</b><b>{`${counter}/99 Tweet Hunter University enrollments left`}</b></Text>)};
    // }
    globalPromotion = {code: "", message: (<Text whiteSpace="pre-line"><Text as="span" fontWeight="800" fontSize="xl">{"Included for Free\n"}</Text><b>{`Get Tweet Hunter University, our Twitter Growth Guide`}</b></Text>)};


    // if (["VIPOFFER", "PRODUCTHUNT", "THEPUP"].includes(discount)) {
    //     priceGrowMonthly = 1;
    //     priceGrowYearly = 1;
    //     priceStartMonthly = 1;
    //     priceStartYearly = 1;
    //     specialNoticeStart = "for 1 month, then $29";
    //     specialNoticeGrow = "for 1 month, then $49";
    // }
    // if (isFromIndia && !discount && billingFrequency === "yearly") {
    //     priceStartYearly = 14;
    //     priceGrowYearly = 22;
    //     priceEnterpriseYearly = 120;
    //     discount="INDIA";
    // }
    // if (isSmallAccount) {
    //     priceGrowMonthly = 29;
    //     specialGrowDiscount = "GROWINGACCOUNT";

    //     if (!(isFromIndia && billingFrequency === "yearly")) {
    //       if (!promotion) {
    //         specialGrowDiscountYearly = "GROWINGACCOUNTYEARLY";
    //         priceGrowYearly = 24;
    //         promotion = growAt29[0];
    //       }
    //     }
    // }

    if (isSmallAccount && !discount && !promotion && !isFromIndia) {
      growPlanPrice = isMonthly ? prices.grow.monthly.isSmallAccount : prices.grow.yearly.isSmallAccount;
      growDiscount = isMonthly ? discounts.grow.default : discounts.grow.yearly;
      promotion = growAt29[0];
    }

    // From India - applied only on yearly plans
    if (!isMonthly && isFromIndia && (!discount || discount==discounts.india.yearly)) {
      startPlanPrice = prices.start.yearly.forIndian;
      growPlanPrice = prices.grow.yearly.forIndian;
      enterprisePlanPrice = prices.enterprise.yearly.forIndian;
      //@ts-ignore
      isSmallAccount = false;
      discount = discounts.india.yearly;
      growDiscount = discounts.india.yearly;
    }

    // custom offers
    if (["VIPOFFER", "PRODUCTHUNT", "THEPUP"].includes(discount)) {
        if (billingFrequency === "monthly") {
            startPlanPrice = 1;
            growPlanPrice = 1;
            specialNoticeStart = "for 1 month, then $29";
            specialNoticeGrow = "for 1 month, then $49"
            discount = originalDiscount;
        }
        else {
            discount = "";
        }
    }

    const onClickStartFreeTrial = () => {
        console.log("click start trial");
    }

    // console.log({specialGrowDiscount});

    const getBanner = () => {

        if (!isFromIndia && !globalPromotion || isEnterpriseOnly)
            return;

        let promo;
        // isFromIndia = true;

        if (isFromIndia)
            promo = <Text fontWeight="medium" as="i">We apply parity pricing for our beloved customers from India 🇮🇳. Enjoy a 50% discount when choosing annual billing.</Text>;
        else if (globalPromotion)
            promo = globalPromotion.message;

        return (
            <Box px={{ base: "6", md: "8" }} marginTop={{ base: "-4", lg: "-8" }} mb={{ base: "10", lg: "4" }} p={5}>
            {/* <Box> */}
                <Box
                    key="banner"
                    id="banner"
                    justifyContent="center"
                    border="4px"
                    maxWidth="lg"
                    margin="auto"
                    borderRadius="xl"
                    borderColor="#da5630"
                    padding="2"
                    textAlign="center"
                >
                    {promo}
                </Box>
            </Box>
        )
    } 

    let bg=mode("gray.600", "white");
    let color=mode("white", "gray.700");
    let name="Write great content 10x faster";
    let plan="enterprise";
    let description="Do less. Get more."
    let price=growPlanPrice;
    let featureIntro="Includes everything in DISCOVER";

    return (
      <Box
        key="plans-root"
        id="plans-root"
        display="flex"
        justifyContent="center"
        mt={10}
        mb={10}
      >
        <Stack id="plans" mt={10}>
          {getBanner()}
          <Center flexDir="column">
            <PricingWrapper
              mb={5}
              {...rest}
              bg={bg}
              maxW="400px"
              minW="300px"
              p={5}
            >
              <Text
                align="left"
                mt={0}
                mb={-2}
                color={color}
                // maxW="16rem"
                mx="auto"
                fontSize="22px"
                fontWeight="700"
              >
                {name}
              </Text>
              {
                <>
                  <Flex alignItems="center">
                    <Text
                      align="left"
                      fontSize="50px"
                      fontWeight="bold"
                      color={color}
                    >
                      ${enterprisePlanPrice} /
                    </Text>
                    <Text
                      ml={4}
                      mt={1}
                      maxW="60px"
                      align="left"
                      fontSize="16px"
                      fontWeight="bold"
                      color={color}
                    >
                      per month
                    </Text>
                  </Flex>
                  {billingFrequency == "yearly" && (
                    <Text opacity="0.6" color={color} fontSize="sm">
                      ${price * 12} billed annually
                    </Text>
                  )}
                  <Flex mt={2} direction="column">
                    <Text
                      align="left"
                      mt={0}
                      mb={0}
                      color={color}
                      // maxW="16rem"
                      // mx="auto"
                      fontSize="md"
                      fontWeight="500"
                    >
                      {description}
                    </Text>
                  </Flex>
                </>
              }
            </PricingWrapper>
            <Payment
              discount={discount}
              color={mode("blackAlpha", "whiteAlpha")}
              bg={bg}
              textColor={color}
              plan={
                plan + (billingFrequency === "yearly" ? "Yearly" : "Monthly")
              }
              billingFrequency={billingFrequency}
              session={session}
              customCancelUrl={
                customCancelUrl ? customCancelUrl : "onboardnewchoice"
              }
              onClickStartFreeTrial={onClickStartFreeTrial}
              source="onboardNewChoice"
              border={"1px solid " + theme.colors.gray[400]}
            />
          </Center>
          <Center mt={{ base: isFromIndia ? "10" : "-2", lg: "-2" }}>
            <Grid
              mt={10}
              mb={10}
              // templateRows="repeat(2, 1fr)"
              // templateColumns="repeat(6, 1fr)"
              templateColumns={{ lg: "repeat(3, 1fr)", md: "repeat(1, 1fr)" }}
              // templateColumns={{sm: 6, md: 6}}
              columnGap={10}
              rowGap={10}
              m={4}
              // maxW="800px"
              alignItems="flex-start"
            >
              <GridItem mb={10} colSpan={1}>
                <PricingCard
                  disableCard={true}
                  discount={discount}
                  bg={mode("gray.200", "gray.600")}
                  color={mode("gray.900", "white")}
                  billingFrequency={billingFrequency}
                  name="DISCOVER"
                  plan="start"
                  description="Write great content 10x faster"
                  price={startPlanPrice}
                  specialNotice={specialNoticeStart}
                  discountedFrom={startPlanPrice !== 29 ? "29" : ""}
                  featureIntro="Includes:"
                  // features={[
                  //     { title: "Over 2M viral tweets library" },
                  //     { title: "10,000+ staff-picked viral tweets across 10 categories" },
                  //     { title: "Personalized tweet inspirations (🤖 )" },
                  //     { title: "Search any topic or @handle" },
                  //     { title: "Save posts to collections" },
                  //     { title: "Tweets & threads scheduling" },
                  //     { title: "Queue system for your tweet agenda" },
                  //     { title: "Evergreen: re-use your best content" },
                  //     // { title: "Growth features (auto-retweet & auto-plug)" },
                  //     { title: "Auto-DM" },
                  //     { title: "Auto-plug" },
                  //     { title: "Auto-retweet" },
                  //     { title: "Hide URL previews" },
                  //     { title: "AI-powered Analytics Dashboard" },
                  //     { title: "Find relevant tweets to engage with" },
                  //     { title: "Add unlimited Twitter accounts" },
                  // ]}
                  //@ts-ignore
                  onClickStartFreeTrial={onClickStartFreeTrial}
                  customCancelUrl={customCancelUrl}
                />
              </GridItem>
              <GridItem mb={10} colSpan={1}>
                {
                  // isSmallAccount && promotion && (
                  promotion && (
                    <Center>
                      <Tag
                        mb={5}
                        p={2}
                        pl={4}
                        pr={4}
                        bg={mode("gray.800", "white")}
                        borderRadius="full"
                        size="md"
                      >
                        <TagLabel
                          fontSize="md"
                          fontWeight="400"
                          color={mode("white", "gray.700")}
                        >
                          {/* {"< 1000 followers? "}<b>Get 40% off GROW</b> */}
                          {promotion?.message}
                        </TagLabel>
                      </Tag>
                    </Center>
                  )
                }
                <PricingCard
                  disableCard={true}
                  discount={growDiscount}
                  bg={mode("gray.600", "white")}
                  color={mode("white", "gray.700")}
                  billingFrequency={billingFrequency}
                  popular={true}
                  name="GROW"
                  plan="grow"
                  description="Unlock the power of AI."
                  price={growPlanPrice}
                  featureIntro="Includes everything in DISCOVER"
                  discountedFrom={growPlanPrice !== 49 ? "49" : ""}
                  specialNotice={specialNoticeGrow}
                  // specialNotice={isSmallAccount ? "Discount less than 1000 followers" : ""}
                  features={[]}
                  customFeature={
                    <Box maxW="340px">
                      <Center
                        fontSize="50px"
                        fontWeight="400"
                        color="gray.600"
                        m={2}
                      >
                        +
                      </Center>
                      <Flex
                        p={5}
                        rounded="xl"
                        border={
                          "solid 2px " +
                          mode(theme.colors.gray[600], theme.colors.gray[200])
                        }
                        bg={mode("white", "#1E1E1E")}
                        flexDirection="column"
                      >
                        <Center mb={4}>
                          <Text>🤖 &nbsp;&nbsp;AI WRITER</Text>
                        </Center>
                        {/* <Center m={5} color="gray.500" fontSize="sm">
                                                <Text>Unlimited generations</Text>
                                            </Center> */}
                        {[
                          "Daily AI-generated tweets",
                          "Re-write tweets you like w/ AI",
                          // "Unlimited use",
                          "Generate thread ideas & hooks",
                          // "Generate thread hooks",
                          "Let the AI finish your posts",
                        ].map((f, index) => (
                          <Flex key={index} m={2}>
                            <Flex
                              mr={2}
                              rounded="full"
                              w={6}
                              h={6}
                              color={mode("white", "#1E1E1E")}
                              alignItems="center"
                              justifyContent="center"
                            >
                              {/* <Text>{index + 1}</Text> */}
                              <Icon
                                as={MdCheckCircle}
                                color={mode("gray.600", "gray.100")}
                                fontSize="20px"
                              />
                            </Flex>
                            <Text>{f}</Text>
                          </Flex>
                        ))}
                      </Flex>
                      <Center
                        fontSize="50px"
                        fontWeight="400"
                        color="gray.600"
                        m={2}
                      >
                        +
                      </Center>
                      <Flex
                        p={5}
                        rounded="xl"
                        border={
                          "solid 2px " +
                          mode(theme.colors.gray[600], theme.colors.gray[200])
                        }
                        bg={mode("white", "#1E1E1E")}
                        flexDirection="column"
                      >
                        <Center mb={4}>
                          <Text>🙋 &nbsp;&nbsp;TWITTER CRM</Text>
                        </Center>
                        {/* <Center m={5} color="gray.500" fontSize="sm">
                                                <Text>Unlimited generations</Text>
                                            </Center> */}
                        {[
                          "Manage lists of people",
                          "Import from tweets & DM interactions",
                          "Engage and send customized bulk DMs",
                        ].map((f, index) => (
                          <Flex key={index} m={2}>
                            <Flex
                              mr={2}
                              rounded="full"
                              w={6}
                              h={6}
                              color={mode("white", "#1E1E1E")}
                              alignItems="center"
                              justifyContent="center"
                            >
                              {/* <Text>{index + 1}</Text> */}
                              <Icon
                                as={MdCheckCircle}
                                color={mode("gray.600", "gray.100")}
                                fontSize="20px"
                              />
                            </Flex>
                            <Text>{f}</Text>
                          </Flex>
                        ))}
                      </Flex>
                    </Box>
                  }
                  //@ts-ignore
                  onClickStartFreeTrial={onClickStartFreeTrial}
                  customCancelUrl={customCancelUrl}
                />
              </GridItem>
              <GridItem colSpan={1}>
                <PricingCard
                  disableCard={true}
                  discount={discount}
                  bg={mode("gray.200", "gray.600")}
                  color={mode("gray.900", "white")}
                  billingFrequency={billingFrequency}
                  name="ENTERPRISE"
                  plan="enterprise"
                  description="Do less. Get more."
                  price={enterprisePlanPrice}
                  featureIntro="Includes everything in GROW"
                  discountedFrom={enterprisePlanPrice !== 200 ? "200" : ""}
                  // type="agency"
                  //   features={[
                  //     // { title: "Unlimited AI generations" },
                  //     {
                  //       title:
                  //         "Custom AI model to get AI-generated tweets adapted to your niche and audience",
                  //     },
                  //     {
                  //       title:
                  //         "Engage with the world at light speed with AI-generated replies",
                  //     },
                  //     { title: "Find email addresses of your Twitter contacts" },
                  //   ]}
                  customFeature={
                    <Box>
                      <Center
                        fontSize="50px"
                        fontWeight="400"
                        color="gray.600"
                        m={2}
                      >
                        +
                      </Center>
                    </Box>
                  }
                  //@ts-ignore
                  onClickStartFreeTrial={onClickStartFreeTrial}
                  customCancelUrl={customCancelUrl}
                />
              </GridItem>
            </Grid>
          </Center>
        </Stack>
      </Box>
    );

}


